module.exports = __webpack_public_path__ + "img/pulled_pork_raw_w_marinade.b3599bc7.jpg";